import React, { Component } from 'react';
import CompanyOverview from '../components/css/dark/img/theme-images/overview.svg';
import Overview from '../components/css/dark/img/theme-images/overview.svg';
import Overview_Selected from '../components/css/dark/img/theme-images/overview-selected.svg';
import Rx_Overview from '../components/css/dark/img/theme-images/rx-overview.svg';
import DashboardSvg from '../components/css/dark/img/theme-images/dashboard.svg';
import dashboard_Selected_Icon from '../components/css/dark/img/theme-images/dashboard-selected.svg';
import Rx_dashboard_Selected_Icon from '../components/css/dark/img/theme-images/rx-dashboard-selected.svg';
import setting_Icon from '../components/css/dark/img/theme-images/settings.svg';
import setting_Selected_Icon from '../components/css/dark/img/theme-images/settings-selected.svg';
import Rx_setting_Selected_Icon from '../components/css/dark/img/theme-images/rx-settings-selected.svg';
import ReportSvg from '../components/css/dark/img/theme-images/report.svg';
import AnalyticsSvg from '../components/css/dark/img/theme-images/anylitics.svg';
import Analytics_Selected from '../components/css/dark/img/theme-images/anylitics-active.svg';
import Rx_Analytics_Selected from '../components/css/dark/img/theme-images/rx-anylitics-active.svg';
import report_Selected_Icon from '../components/css/dark/img/theme-images/report-selected.svg';
import Rx_report_Selected_Icon from '../components/css/dark/img/theme-images/rx-report-selected.svg';
import Logout from '../components/css/dark/img/theme-images/logout.svg';
import closeWhite from '../components/css/dark/img/theme-images/closeWhite.svg';
import infoIcon from '../components/css/dark/img/info-icon-green.svg';
import rxInfoIcon from '../components/css/dark/img/rx-info-icon-green.svg';
import Filter from '../components/css/dark/img/theme-images/advance-filter.svg';
import FilterActive from '../components/css/dark/img/theme-images/advance-filter-active.svg';
import RxFilterActive from '../components/css/dark/img/theme-images/rx-advance-filter-active.svg';
import { BrowserRouter as Router, Route, NavLink, Link } from 'react-router-dom';
import $ from 'jquery';
import { userService } from '../_services';
import paymentIcon from '../components/css/dark/img/theme-images/payment.svg';
import paymentSelected from '../components/css/dark/img/theme-images/payment-selected.svg';
import RxPaymentSelected from '../components/css/dark/img/theme-images/rx-payment-selected.svg';
import * as signalR from '@aspnet/signalr';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr/dist/browser/signalr.min.js';
import Compliance from '../components/css/dark/img/theme-images/compliance.svg';
import CookieInfo from '../components/css/dark/img/theme-images/cookie-info.svg';
import MilestonePopup from '../components/Distributor/MilestonePopup';
import { openCookiePreferences } from '../cookie-consent/cookie-consent.config';

class Sidebar extends Component {
    constructor(props) {
        super(props);
        var isfuser = false;
        if (localStorage.getItem('x_resu_t_p') != "" && localStorage.getItem('x_resu_t_p') != null && localStorage.getItem('x_resu_t_p') != undefined) {
            isfuser = (localStorage.getItem('x_resu_t_p') === 'true');
        }
        let RoundPicName = "--";
        try {
            let JsonData = JSON.parse(localStorage.getItem('user'));
            let Username_Space_Split = JsonData.username.split(' ');
            var Username_Hyphen_Split = JsonData.username.split('-');
            if (Username_Space_Split.length > 1) {
                RoundPicName = JsonData.username.split(' ')[0].substring(JsonData.username.split(' ')[0], 1) + '' + JsonData.username.split(' ')[1].substring(JsonData.username.split(' ')[1], 1);
            }
            else if (Username_Hyphen_Split.length > 1) {
                RoundPicName = JsonData.username.split('-')[0].substring(JsonData.username.split('-')[0], 1) + '' + JsonData.username.split('-')[1].substring(JsonData.username.split('-')[1], 1);
            }
            else {
                RoundPicName = JsonData.username.substring(0, 1);
            }
        }
        catch (error) {
            RoundPicName = "--";
        }
        this.state = {
            menuSelected: false,
            // dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
            userdata: JSON.parse(localStorage.getItem('user')),
            AnalyticList: [],
            IsFinanceUser: isfuser,
            dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
            // userdata: JSON.parse(localStorage.getItem('user')),
            _RoundPicName: RoundPicName,
            closeSubMenu: true,
            milestonePopup: false,
            tierContent: [],
            isEnrollEndpointEnabled: false,
            API_Signup: false,
            Enrollment_Center_Signup: false,
            Client_Acces_Link_Signup: false
            //AnalyticList: []
        };
        this.closeSidebar = this.closeSidebar.bind(this);
        //try {
        //    this.state = {
        //        // users: null,
        //        dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
        //        userdata: JSON.parse(localStorage.getItem('user')),
        //        _RoundPicName: RoundPicName,
        //        AnalyticList:[]
        //    };
        //}
        //catch (error) { }
    }
    componentDidMount() {
        this.GetWholesalers_Enrollment_API_Status(this.state.userdata.wholesaler_Id);
        $("#main-menu a").click(function (event) {
            $("body").removeClass('no-scroll');
            window.scrollTo(0, 0);
            if ($('body').hasClass("sub-menu-active")) {
                if ($(event.target).parent().parent().hasClass("non-submenu")) {
                    $('.sidebar-submenu').hide();
                    $('body').toggleClass('sub-menu-active');
                }
            }
        });
        $('.menu-text.down-arrow').click((event) => {
            $('.sidebar-submenu').slideToggle();
            $('body').toggleClass('sub-menu-active');
            event.preventDefault();
            return false;
            event.stopPropagation();
        });
        this.setState({ AnalyticList: JSON.parse(localStorage.getItem('analytics_data')) });
        if (this.state.userdata["userrole"] == 'Distributor') {
            this.TierProperties(this.state.userdata["userrole"], parseInt(this.state.userdata["distributor_UserId"]), parseInt(this.state.userdata["wholesaler_Id"]));
        }
        // this.updateUI_SignalR();
        if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            $('body').addClass('rx-user');
        }
    }
    componentDidUpdate() {
        try {
            var localstoragedata = JSON.parse(localStorage.getItem('user'));
            if (localstoragedata.userrole.toLowerCase() == 'wholesaler') {
                this.updateUI_SignalR();
            }
        }
        catch (error) {

        }
    }
    GetWholesalers_Enrollment_API_Status(Wh_Id) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Wh_Id })
            };
            return fetch(`/api/Analytic/getWholesalers_Enrollment_API_Status`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ isEnrollEndpointEnabled: apidata[0].colValue, API_Signup: apidata[1].colValue, Enrollment_Center_Signup: apidata[2].colValue, Client_Acces_Link_Signup: apidata[3].colValue });
                        }
                    }
                    catch (error) {
                        this.setState({ loading: false, error: 'Error. Please try later.' });
                        return false;
                    }
                });
        }
        catch (error) {
            this.setState({ loading: false, error: 'Error. Whoops, something went wrong. Please try again.' });
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    closeSidebar() {
        $(".sidebar-section").animate({
            left: -340 + 'px'
        }, 1000);
        $("body").removeClass('no-scroll');
    }
    deleteUser() {
        userService.logout();
        window.localStorage.removeItem("user");

        window.xl();
        window.location.href = window.location.origin;

    }
    updateUI_SignalR = () => {
        var connection = new signalR.HubConnectionBuilder().withUrl("/fuser").build();
        try {
            connection.start().then(() => {
                connection.on("ReceiveMessage", (whemail, status, Wh_Id_) => {
                    var isfuser = false;
                    var localstoragedata = JSON.parse(localStorage.getItem('user'));
                    isfuser = (localStorage.getItem('x_resu_t_p') === 'true');
                    if (localstoragedata != '' && localstoragedata != null && localstoragedata != undefined && localstoragedata != '{}') {
                        if (localstoragedata.userrole.toLowerCase() == 'wholesaler') {
                            if (localstoragedata.wholesaler_Id == Wh_Id_) {
                                if (localstoragedata.email.toLowerCase() == whemail.toLowerCase()) {
                                    if (isfuser != status) {
                                        localStorage.setItem('x_resu_t_p', true);
                                        this.setState({ IsFinanceUser: true });
                                    }
                                }
                                else {
                                    localStorage.setItem('x_resu_t_p', false);
                                    this.setState({ IsFinanceUser: false });
                                }
                            }
                        }
                    }
                });
            });
        }
        catch (err) {
        }
    }
    findPercent = (tierFrom, tierTo, cTransition) => {
        let length = tierTo - tierFrom;
        let pLength = cTransition - tierFrom;
        return parseInt((pLength / length) * 100)
    }
    toggleMileston = () => {
        this.setState({ milestonePopup: !this.state.milestonePopup });
    }
    TierProperties = (userType, userId, whId) => {
        try {
            userService.TierProperties(userType, userId, whId).then(
                apidata => {
                    if (apidata.length > 0) {
                        this.setState({ tierContent: apidata });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    handleOver = () => {
        try {
            $('.range').addClass('change');
        } catch (error) { }
    }
    handleOut = () => {
        try {
            $('.range').removeClass('change');
        } catch (error) { }
    }
    render() {
        let complianceUrl;
        if (window.location.host.toLowerCase() == "https://reporting.nulifespanrx.com" || window.location.host.toLowerCase() == "https://reporting.rxhacker.com" || window.location.host.toLowerCase() == "https://tempfilter-dev.glichealth.com") {
            complianceUrl = "https://nulifespanrx.com/compliance";
        } else {
            if ((this.state.userdata.userrole == "Distributor" && this.state.userdata.wholesaler_Id == 61) || (this.state.userdata.userrole == "Wholesaler" && this.state.userdata.wholesaler_Id == 61)) {
                complianceUrl = "https://nulifespanrx.com/compliance";
            } else {
                if (window.location.host.toLowerCase() == "reporting.glichealth.com" || window.location.host.toLowerCase() == "staging.glichealth.com") {
                    complianceUrl = "https://www.glichealth.com/compliance-resources";
                } else {
                    complianceUrl = "https://dev-web.glichealth.com/compliance-resources";
                }
            }
        }

        let profilename = "--";
        try {
            profilename = this.state._RoundPicName;
        } catch (error) {
            profilename = "--";
        }
        var userrole = this.state.userdata.userrole;
        try {
            if (this.state.userdata.isBrokerTypeUser) {
                userrole = "Broker";
            }
        }
        catch (error) { }
        let styleWidth, stylePosition, tierFrom, tierTo, tierName, nMilestonePoints, cTransition, tierIconUrl, lastTierName, styleAngle;
        let tierDetails = [];
        if (this.state.tierContent.length > 0) {
            tierName = this.state.tierContent[0].tierName;
            let lastIndex = this.state.tierContent[0].tierJson.length - 1;
            lastTierName = this.state.tierContent[0].tierJson[lastIndex].tierName;
            let mileston = this.state.tierContent[0].tierJson.filter((item) => { return item.tierName == tierName });
            tierFrom = mileston[0].from;
            tierTo = mileston[0].to;
            nMilestonePoints = (tierTo + 1) - this.state.tierContent[0].claims;
            cTransition = this.state.tierContent[0].claims;
            tierIconUrl = mileston[0].tierIcon;
            let percent;
            if (tierName == lastTierName) {
                percent = 100 + '%';
            } else {
                let percentData = this.findPercent(tierFrom, tierTo, cTransition);
                percent = percentData + '%';
                if (percentData > 5) {
                    if (percentData > 60) {
                        stylePosition = {
                            right: '0px',
                            marginRight: '-8px'
                        }
                        styleAngle = {
                            right: '4px',
                        }
                    } else {
                        stylePosition = {
                            right: 0 + 'px',
                            marginRight: '-88px'
                        }
                        styleAngle = {
                            left: '15px',
                        }
                    }
                } else {
                    stylePosition = {
                        right: '0px',
                        marginRight: '-100px'
                    }
                    styleAngle = {
                        left: '4px',
                    }
                }
            }
            styleWidth = {
                width: percent
            }
            tierDetails = [{ tierName: tierName, lastTierName: lastTierName, tierFrom: tierFrom, tierTo: tierTo, stylePosition: stylePosition, styleAngle: styleAngle, styleWidth: styleWidth, nMilestonePoints: nMilestonePoints, cTransition: cTransition, tierIconUrl: tierIconUrl, tierJson: this.state.tierContent[0].tierJson }];
        }
        return (
            <div className={this.state.tierContent.length > 0 && this.state.userdata["userrole"] == 'Distributor' ? "sidebar-section tierMilestone" : "sidebar-section"}>
                <div className="hide">
                    <div className="username_sec">
                        <div className="ppic">{profilename}</div >
                        {/* <div className="ppic">{this.state.userdata.username.split(' ')[0].substring(this.state.userdata.username.split(' ')[0], 1) + '' + this.state.userdata.username.split(' ')[1].substring(this.state.userdata.username.split(' ')[1], 1)}</div >*/}
                        <div className="name">
                            <p>{this.state.userdata.username}</p>
                            <p>{userrole}</p>
                        </div>
                    </div>
                    <img className="closeSidebar" onClick={this.closeSidebar} src={closeWhite} alt="close white" />
                </div>
                {
                    this.state.tierContent.length > 0 && this.state.userdata["userrole"] == 'Distributor' ?
                        <div class="range">
                            <span className="info"><img className="tier-icon" src={tierIconUrl} alt="icon" /><label className="tier-name">{tierName}</label>{window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? <img onMouseOver={this.handleOver} onMouseOut={this.handleOut} onClick={this.toggleMileston} className="info-icon" src={rxInfoIcon} alt="icon" /> : <img onMouseOver={this.handleOver} onMouseOut={this.handleOut} onClick={this.toggleMileston} className="info-icon" src={infoIcon} alt="icon" />}</span>
                            <span className="bar"><span className="green-bar" style={styleWidth}><span style={stylePosition} className="green-tooltip">{cTransition > 1 ? cTransition + ' Transactions' : cTransition + ' Transaction'}<span style={styleAngle} className="angle">&nbsp;</span></span></span></span>
                            <span className="min">{tierFrom}</span><span className="max">{tierTo}</span>
                            {
                                tierName != lastTierName ?
                                    <span className="remain">{nMilestonePoints} {nMilestonePoints > 1 ? ' transactions' : ' transaction'} to reach the next level</span>
                                    : null
                            }
                        </div> : null
                }

                <ul id="main-menu">
                    <li className="non-submenu"><NavLink to="/dashboard" activeClassName="active"><img className="unselected" src={DashboardSvg} alt="" /><img className="selected" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? Rx_dashboard_Selected_Icon : dashboard_Selected_Icon} alt="" /><span className="menu-text">Transactions</span><span className="tooltiptext">Transactions</span></NavLink></li>
                    {
                        this.state.userdata.userrole === "Admin" ?
                            <li className="non-submenu"><NavLink to="/admin/companyOverview" activeClassName="active"><img className="unselected overview" src={Overview} alt="" /><img className="selected overview" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? Rx_Overview : Overview_Selected} alt="" /><span className="menu-text">Company Overview</span><span className="tooltiptext">Company Overview</span></NavLink></li>
                            : null
                    }
                    {
                        this.state.userdata.userrole === "Wholesaler" ?
                            <li className="analytics-menu"><img className="unselected report" src={AnalyticsSvg} alt="" /><img className="selected report" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? Rx_Analytics_Selected : Analytics_Selected} alt="" /><span className="menu-text down-arrow">Analytics</span><span className="tooltiptext">Analytics</span>
                                <ul className="sidebar-submenu">
                                    {
                                        (this.state.API_Signup === false && this.state.Enrollment_Center_Signup === false && this.state.Client_Acces_Link_Signup === false) ? null :
                                            <li><NavLink to="/wholesaler/analytics/signups" activeClassName="active-change"><span className="menu-text submenu-open">Signups</span><span className="tooltiptext">Signups</span></NavLink></li>
                                    }
                                    <li><NavLink to="/wholesaler/analytics/geographic" activeClassName="active active-change"><span className="menu-text submenu-open">Geographic</span><span className="tooltiptext">Geographic</span></NavLink></li>
                                    <li><NavLink to="/wholesaler/analytics/pharmacies" activeClassName="active"><span className="menu-text">Pharmacies</span><span className="tooltiptext">Pharmacies</span></NavLink></li>
                                </ul>
                            </li> : null
                    }
                    {
                        this.state.userdata.userrole === "Admin" && this.state.userdata.isForAnalytic ?
                            <li className="analytics-menu"><img className="unselected report" src={AnalyticsSvg} alt="" /><img className="selected report" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? Rx_Analytics_Selected : Analytics_Selected} alt="" /><span className="menu-text down-arrow">Analytics</span><span className="tooltiptext">Analytics</span>
                                <ul className="sidebar-submenu">
                                    {
                                        this.state.userdata.isForAnalytic ?
                                            <li><NavLink to="/admin/analytics/signups" activeClassName="active-change"><span className="menu-text submenu-open">Signups</span><span className="tooltiptext">Signups</span></NavLink></li> : null
                                    }
                                    <li><NavLink to="/admin/analytics/geographic" activeClassName="active active-change"><span className="menu-text submenu-open">Geographic</span><span className="tooltiptext">Geographic</span></NavLink></li>
                                    <li><NavLink to="/admin/analytics/pharmacies" activeClassName="active"><span className="menu-text">Pharmacies</span><span className="tooltiptext">Pharmacies</span></NavLink></li>
                                    <li><NavLink to="/admin/analytics/publicapi" activeClassName="active"><span className="menu-text">Public API</span><span className="tooltiptext">Public API</span></NavLink></li>
                                </ul>
                            </li> : null
                    }
                    {
                        this.state.userdata.userrole != "Distributor" && this.state.userdata.userrole != "Admin" && this.state.userdata.userrole != "SubAdmin" ?
                            <li className="non-submenu"><NavLink to="/wholesaler/report" activeClassName="active"><img className="unselected report" src={ReportSvg} alt="" /><img className="selected report" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? Rx_report_Selected_Icon : report_Selected_Icon} alt="" /><span className="menu-text">Reports</span><span className="tooltiptext">Reports</span></NavLink></li> : null
                    }
                    {
                        <li className="non-submenu"><NavLink to="/filter" activeClassName="active"><img className="unselected" src={Filter} alt="" /><img className="selected" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? RxFilterActive : FilterActive} alt="" /><span className="menu-text">Filter</span><span className="tooltiptext">Filter</span></NavLink></li>
                    }
                    {
                        this.state.userdata.userrole != "Distributor" && this.state.userdata.userrole != "Admin" && this.state.userdata.userrole != "SubAdmin" ?
                            <li className="non-submenu"><NavLink to="/wholesaler/tools" activeClassName="active"><img className="unselected" src={setting_Icon} alt="" /><img className="selected" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? Rx_setting_Selected_Icon : setting_Selected_Icon} alt="" /><span className="menu-text">Tools</span><span className="tooltiptext">Tools</span></NavLink></li> : null
                    }
                    {
                        this.state.userdata.userrole == "Distributor" ?
                            <li className="non-submenu"><NavLink to="/distributor/tools" activeClassName="active"><img className="unselected" src={setting_Icon} alt="" /><img className="selected" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? Rx_setting_Selected_Icon : setting_Selected_Icon} alt="" /><span className="menu-text">Tools</span><span className="tooltiptext">Tools</span></NavLink></li> : null
                    }
                    {
                        this.state.userdata.userrole == "Admin" ?
                            <li className="non-submenu"><NavLink to="/admin/report" activeClassName="active"><img className="unselected" src={ReportSvg} alt="" /><img className="selected" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? Rx_report_Selected_Icon : report_Selected_Icon} alt="" /><span className="menu-text">Reports</span><span className="tooltiptext">Reports</span></NavLink></li> : null
                    }
                    {
                        this.state.userdata.userrole == "Admin" ?
                            <li className="non-submenu"><NavLink to="/admin/tools" activeClassName="active"><img className="unselected" src={setting_Icon} alt="" /><img className="selected" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? Rx_setting_Selected_Icon : setting_Selected_Icon} alt="" /><span className="menu-text">Tools</span><span className="tooltiptext">Tools</span></NavLink></li> : null
                    }
                    {
                        this.state.userdata.userrole == "Wholesaler" && this.state.IsFinanceUser == true ?
                            <li className="non-submenu"><NavLink to="/wholesaler/payment" activeClassName="active"><img className="unselected" src={paymentIcon} alt="" /><img className="selected" src={window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com" ? RxPaymentSelected : paymentSelected} alt="" /><span className="menu-text">Payments</span><span className="tooltiptext">Payments</span></NavLink></li> : null
                    }
                    {/*
                        <li className="currentDisplaynone"><img src={Reports} alt="" /><span className="menu-text">Reports</span><span className="tooltiptext">Reports</span></li>
                        <li className="currentDisplaynone"><img src={Settings} alt="" /><span className="menu-text">Settings</span><span className="tooltiptext">Settings</span></li>
                        <li className="currentDisplaynone"><img src={Help} alt="" /><span className="menu-text">Help</span><span className="tooltiptext">Help</span></li>
                        */}
                    <li className="non-submenu"><a href={complianceUrl} target="_blank"><img src={Compliance} alt="" /><span className="menu-text">Compliance Resources</span></a><span className="tooltiptext">Compliance Resources</span></li>
                    <li className="non-submenu"><button type="button" className="cookie-menu-link" onClick={() => openCookiePreferences()}><img src={CookieInfo} alt="" /><span className="menu-text">Cookie preferences</span></button><span className="tooltiptext">Cookie preferences</span></li>
                    <li><img onClick={this.deleteUser} src={Logout} alt="" /><span onClick={this.deleteUser} className="menu-text">Logout</span><span className="tooltiptext" >Logout</span></li>
                </ul>
                {
                    this.state.milestonePopup ?
                        <MilestonePopup tierDetails={tierDetails} titleText={'RxHacker RockStar Revenue Program'} closeMilestonePopup={this.toggleMileston} /> : null
                }

            </div>
        )

    }

}
export default Sidebar;